/**
 * Kaya Unite — Scroll-typing animation for mobile header.
 *
 * Phase 1 (0 %–25 % scroll): types "Kaya Unite"
 * Phase 2 (25 %–40 % scroll): types "keep blazin'" in italic
 * Both erase in reverse on scroll-up. Blinking caret while typing,
 * hidden once both phrases are complete.
 * Only active on viewports below 1000 px (Prestige's desktop breakpoint).
 */
(function () {
  'use strict';

  var TEXT_1 = 'Kaya Unite';
  var TEXT_2 = "keep blazin'";
  var PHASE_1_END = 0.25; // primary text complete at 25 %
  var PHASE_2_START = 0.40; // tagline starts at 40 % (25–40 % = caret blink pause)
  var PHASE_2_END = 0.65; // tagline complete at 65 %
  var DESKTOP_BP = 1000;

  var wrapper = document.querySelector('[data-kaya-scroll-text]');
  if (!wrapper) return;

  var elPrimary = wrapper.querySelector('[data-kaya-primary]');
  var elTagline = wrapper.querySelector('[data-kaya-tagline]');
  if (!elPrimary || !elTagline) return;

  var len1 = TEXT_1.length;
  var len2 = TEXT_2.length;
  var ticking = false;
  var isMobile = window.innerWidth < DESKTOP_BP;
  var lastChars1 = -1;
  var lastChars2 = -1;

  function getScrollPercent() {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var docHeight = document.documentElement.scrollHeight - window.innerHeight;
    if (docHeight <= 0) return 0;
    return scrollTop / docHeight;
  }

  function update() {
    ticking = false;
    if (!isMobile) return;

    var pct = getScrollPercent();

    // Phase 1: 0 → PHASE_1_END maps to 0 → len1
    var progress1 = Math.min(pct / PHASE_1_END, 1);
    var chars1 = Math.round(progress1 * len1);

    // Phase 2: PHASE_2_START → PHASE_2_END maps to 0 → len2
    var chars2 = 0;
    if (pct > PHASE_2_START) {
      var progress2 = Math.min((pct - PHASE_2_START) / (PHASE_2_END - PHASE_2_START), 1);
      chars2 = Math.round(progress2 * len2);
    }

    if (chars1 === lastChars1 && chars2 === lastChars2) return;
    lastChars1 = chars1;
    lastChars2 = chars2;

    // Update primary text
    elPrimary.textContent = chars1 > 0 ? TEXT_1.slice(0, chars1) : '';

    // Update tagline
    elTagline.textContent = chars2 > 0 ? TEXT_2.slice(0, chars2) : '';

    // Wrapper visibility
    if (chars1 === 0 && chars2 === 0) {
      wrapper.classList.remove('is-active');
      wrapper.classList.remove('is-complete');
    } else {
      wrapper.classList.add('is-active');
      if (chars1 === len1 && chars2 === len2) {
        wrapper.classList.add('is-complete');
      } else {
        wrapper.classList.remove('is-complete');
      }
    }
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }

  function onResize() {
    isMobile = window.innerWidth < DESKTOP_BP;
    if (!isMobile) {
      elPrimary.textContent = '';
      elTagline.textContent = '';
      wrapper.classList.remove('is-active');
      wrapper.classList.remove('is-complete');
      lastChars1 = -1;
      lastChars2 = -1;
    } else {
      lastChars1 = -1;
      lastChars2 = -1;
      update();
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onResize, { passive: true });

  // Initial evaluation (page may already be scrolled on load)
  update();
})();
